export enum BillingPaymentTypes {
  DEFAULT = 'PT',
  MEDICARE = 'MC',
  MEDICAID = 'MD',
  PRIVATE = 'PI',
}
